
//@ message - String("Hello There")
//@ type- Sring(warning/success/info)
//@ delayAmount - time in milli-seconds

import * as React from 'react';
// const classnames = require('classnames')
import { TOAST_DELAY_TIME,TOAST_CLASS_LIST,TOAST_ICON_LIST} from './constants';
import BodyPortal from '../BodyPortal';
import Icon from '../../icons';
import {StringConstants} from '../../containers/WorkkardDetail/constants';

export default class Toast extends React.Component {
    timeouts;
    constructor(props){
        super(props);
        this.state = {
            showToast : false,
        }

    }

    componentWillMount(){
        if(this.props.autoClose){
            this.timeouts =  window.setTimeout(()=>{
                this.props.closeToast();
            }, this.props.delayTime || TOAST_DELAY_TIME);
        }
    }

    componentWillUnmount(){
        if(this.timeouts){
            clearTimeout(this.timeouts)
        }
    }

    render(){
        if(this.props.show){
            let hash = this.props.entityType == StringConstants.activity ? "an" : "cn";
            return(
            <BodyPortal>                    
                <div className={ `toast mobToast ${this.props.type ? TOAST_CLASS_LIST[this.props.type] : TOAST_CLASS_LIST["success"]} rowFlex rowSpaceBetween alignMiddle animated fast__12ms bounceUp`} style={{ "zIndex" : this.props.hasOwnProperty("addStyle") && this.props.addStyle ? "9" : "" }}>
                    <div className="flexGrow rowFlex alignMiddle mr__1">
                        {!this.props.isCloseIcon  ? 
                        <span className="alignMiddle">
                         <Icon name={`${this.props.iconType ? TOAST_ICON_LIST[this.props.iconType] : "toastError"}`} 
                         className="icon mr__1" /> 
                        {this.props.message}
                        </span> : this.props.message }
                    </div>
                    {
                        this.props.isCloseIcon ?
                        <a className="closeIcon" href="javascript:void(0)" onClick={()=>{ this.props.closeToast()}}><Icon name="closeCircle" className="icon" /></a>
                        :
                        null
                    }
                    { this.props.showActions && <div className="rowFlex alignMiddle flexNone ml__1">
                        <a href="javascript:void();" onClick={() => this.props.onViewToastClick(this.props.entityType, this.props.cId, this.props.actId, hash)} className="mr__1 white">{this.props.entityType=="timezone" ? "Yes" :"view"}</a>                             
                        <a href="javascript:void();" onClick={this.props.closeToast} className="gray">{this.props.entityType=="timezone" ? "No" :"close"}</a>
                    </div>
                    } 
                </div>                    
            </BodyPortal>
            )
        }else{
            return null;
        }

    }
}


